<template>
  <div style="margin: 15px; display: grid;min-width: 340px;justify-content: center;">
  <div
          class="leaderboard-wrapper"
          :class="{'top-players-wrapper': topPlayers}"
  >
    <div class="row row--top-20">
      <div class="col-md-12">
        <div class="table-container">
          <table class="table">

            <tbody class="table__tbody">
            <tr  v-for="(player, index) in getScoresByPlayer"
                 :key="player.id" class="table-row table-row--chris"
                 :class="{ 'current-player': player.id === playerId }"
            >
              <td class="table-row__td">

                <span>
                  <h3 :class="{ 'position-current_name': player.id === playerId }" style="margin: 8px;">{{player.rank}}</h3>
                </span>

              </td>
              <td class="table-row__td" style="width: 70%;">
                <div :class="{
                'table-row__info':!topPlayer(index+1),
                'table-row__info2':topPlayer(index+1)
                }">
                    <div class="table-row__img" v-if="!topPlayer(index+1)">
                        <img :class="{ 'position-current': player.id === playerId }" class="position-one" :src="'https://avatars.dicebear.com/v2/avataaars/'+index+'.svg'" alt="icon">
                    </div>
                    <div v-if="topPlayer(index+1)" class="table-row__img2">
                        <img :class="{ 'position-current': player.id === playerId }" class="position-one" :src="image_url" alt="icon">
                    </div>
                  <div>
                  <p v-if="!topPlayer(index+1)" :class="{ 'position-current_name': player.id === playerId }" class="table-row__name">{{ player.nickname }}</p>
                  <p v-else :class="{ 'position-current_name': player.id === playerId }" class="table-row__name2">{{ player.nickname }}</p>
                  <span class="table-row__small">
                  <svg class="coin" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 504.19 504.19" style="enable-background:new 0 0 504.19 504.19;" xml:space="preserve">
<g>
	<path style="fill:#B19046;" d="M26.468,225.627v52.936c0,124.61,101.017,225.627,225.627,225.627s225.627-101.017,225.627-225.627
		v-52.936H26.468z"/>
	<circle style="fill:#F0C419;" cx="252.095" cy="225.627" r="225.627"/>
	<circle style="fill:#B19046;" cx="252.095" cy="225.627" r="173.559"/>
	<ellipse style="fill:#F3D55B;" cx="252.095" cy="238.644" rx="156.203" ry="160.542"/>
	<path style="fill:#FF5364;" d="M259.957,126.238l25.487,49.334c1.323,2.537,3.795,4.275,6.63,4.66l56.554,7.854
		c3.316,0.438,6.085,2.744,7.117,5.925c1.032,3.182,0.144,6.673-2.283,8.975l-40.578,37.784c-2.138,1.992-3.119,4.934-2.603,7.81
		l9.624,53.604c0.542,3.278-0.81,6.582-3.496,8.539c-2.686,1.957-6.245,2.232-9.2,0.711l-51.079-25.661
		c-2.525-1.258-5.494-1.258-8.018,0l-51.079,25.661c-2.955,1.521-6.514,1.245-9.2-0.711c-2.686-1.957-4.038-5.261-3.496-8.539
		l9.615-53.595c0.516-2.877-0.465-5.818-2.603-7.81l-40.578-37.784c-2.427-2.302-3.315-5.793-2.283-8.975
		c1.032-3.182,3.801-5.487,7.117-5.925l56.554-7.854c2.835-0.386,5.307-2.123,6.63-4.66l25.487-49.334
		c1.543-2.896,4.556-4.707,7.838-4.708C255.396,121.537,258.411,123.344,259.957,126.238z"/>
</g>
</svg>
                  {{ Math.round(player.points) }}
                  </span>
                  </div>
                </div>
              </td>

              <td class="table-row__td">
                <!--<svg style="width: 25px;" id="Layer_1" enable-background="new 0 0 256 256" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg"><switch><foreignObject height="1" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/" width="1"/><g><g><path d="m178.06 64.099h-100.12c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5h100.12c1.381 0 2.5 1.119 2.5 2.5 0 1.38-1.12 2.5-2.5 2.5z" fill="#ebe7f2"/><path d="m192.139 109.939h-128.278c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5h128.277c1.381 0 2.5 1.119 2.5 2.5.001 1.381-1.118 2.5-2.499 2.5z" fill="#ebe7f2"/><path d="m193.452 107.184c-1.137-.782-2.695-.491-3.476.649l-54.802 79.965 26.585-86.814h15.907c1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5h-14.376l11.145-36.393 16.225 28.55c.683 1.2 2.209 1.62 3.409.938s1.62-2.208.938-3.409l-19.091-33.594c-.444-.782-1.274-1.265-2.174-1.265h-91.485c-.899 0-1.729.483-2.174 1.265l-25.671 45.172c-.473.832-.429 1.86.111 2.648l22.379 32.655c.484.707 1.268 1.087 2.064 1.087.487 0 .979-.142 1.411-.438 1.139-.78 1.43-2.336.649-3.475l-19.697-28.742h32.91l26.584 86.813-28.588-41.715c-.781-1.14-2.338-1.43-3.476-.649-1.139.78-1.43 2.336-.649 3.475l37.826 55.194c.467.68 1.238 1.087 2.063 1.087s1.596-.407 2.063-1.087l64.039-93.443c.781-1.138.49-2.694-.649-3.474zm-65.452-49.54 27.083 38.339h-54.167zm-31.012 35.235-11.351-37.068h37.536zm35.839-37.068h37.536l-11.351 37.068zm-71.945 40.172 20.683-36.394 11.145 36.394zm95.648 5-28.53 93.167-28.53-93.167z" fill="#846f75"/><g fill="#ed9abc"><path d="m198.165 120.778c-3.252 0-5.897-2.646-5.897-5.898 0-5.789-4.71-10.499-10.499-10.499-3.252 0-5.898-2.646-5.898-5.898s2.646-5.898 5.898-5.898c5.789 0 10.499-4.71 10.499-10.499 0-3.252 2.646-5.898 5.897-5.898 3.252 0 5.899 2.646 5.899 5.898 0 5.789 4.71 10.499 10.499 10.499 3.252 0 5.898 2.646 5.898 5.898s-2.646 5.898-5.898 5.898c-5.789 0-10.499 4.71-10.499 10.499 0 3.252-2.647 5.898-5.899 5.898zm0-39.59c-.495 0-.897.403-.897.898 0 8.546-6.953 15.499-15.499 15.499-.495 0-.898.403-.898.898s.403.898.898.898c8.546 0 15.499 6.953 15.499 15.499 0 .495.402.898.897.898s.899-.403.899-.898c0-8.546 6.953-15.499 15.499-15.499.495 0 .898-.403.898-.898s-.402-.898-.898-.898c-8.546 0-15.499-6.953-15.499-15.499 0-.495-.404-.898-.899-.898z"/><path d="m84.598 158.308c-2.946 0-5.344-2.397-5.344-5.344 0-4.621-3.76-8.38-8.381-8.38-2.946 0-5.344-2.397-5.344-5.344s2.398-5.344 5.344-5.344c4.621 0 8.381-3.76 8.381-8.381 0-2.947 2.397-5.344 5.344-5.344s5.345 2.397 5.345 5.344c0 4.621 3.759 8.381 8.38 8.381 2.947 0 5.345 2.397 5.345 5.344s-2.397 5.344-5.345 5.344c-4.621 0-8.38 3.759-8.38 8.38-.001 2.946-2.398 5.344-5.345 5.344zm0-33.138c-.189 0-.344.154-.344.344 0 7.378-6.003 13.381-13.381 13.381-.189 0-.344.154-.344.344s.154.344.344.344c7.378 0 13.381 6.002 13.381 13.38 0 .19.154.344.344.344s.345-.154.345-.344c0-7.378 6.002-13.38 13.38-13.38.19 0 .345-.154.345-.344 0-.189-.154-.344-.345-.344-7.378 0-13.38-6.002-13.38-13.381-.001-.19-.155-.344-.345-.344z"/></g></g></g></switch></svg>
                -->
                  <span
                          class="crown"
                          :data-rank="index"
                          v-if="!playerFour(index+1)"
                  >
          <svg
                  stroke-width="0"
                  viewBox="0 0 640 512"
                  xmlns="http://www.w3.org/2000/svg"
          >
            <path
                    d="M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
            ></path>
          </svg>
        </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import {scoresByPlayer} from "./scoreHelpers"
export default {
  props: {
    topPlayers: {
      type: Boolean,
      default: false
    }
  },
  data()
  {
    return{
      playerAnswer:{'isCorrect':true}
    }
  },
  computed: {
    image_url()
    {
        return require('../../../public/people.svg');
    },
    playerId() {
      return Number(this.$store.state.scores.playerOne.id);
    },
    getScoresByPlayer() {
      //const players = this.$store.state.scores;
      return this.$store.state.players;
    }
  },
  methods:
  {
    topPlayer(player)
    {
      return player ===1;
    },
    playerFour(player)
    {
      return player > 3;
    }
  },
  mounted() {
    scoresByPlayer();
    if(this.topPlayers)
    {
        this.$confetti.start({
            particlesPerFrame:0.25
        });
    }
  }
};
</script>

<style lang="sass" scoped>
.coin
  height: 12px
.leaderboard-wrapper
  position: relative
  overflow: auto
  height: 100%
  width: 100%
  min-width: 340px

.leaderboard
  position: absolute
  top: 0
  left: 0
  right: 0
  height: 100%
  width: 100%
  list-style: none
  padding: 0
  padding-top: 1rem

.top-players-wrapper
  height: 60vh

.top-players
  position: static
  padding: 0
  margin: 0 1rem
  width: auto
  height: auto

.item
  display: flex
  align-items: center
  min-height: 1em
  padding: 0.5rem 1rem
  border-radius: 5px
  &:nth-child(odd)
    background: $color-gray--lightest

  .rank
    font-weight: normal
    font-size: $font-size-small
    padding-right: 1rem

  .points
    margin-left: auto

  .crown
    padding-right: 0.5rem

.current-player>td
    border-bottom: 2px solid #fbb03b !important
    border-top: 2px solid #fbb03b !important

.current-player
    background-color: #fbb03b1c !important
//list
.row__title
  color: #53646f
  font-weight: 400
  font-size: 20px
  margin: 0

.row--top-40
  margin-top: 40px

.row--top-20
  margin-top: 20px
  overflow: auto

.table__th
  color: #9eabb4
  font-weight: 500
  font-size: 12px
  text-transform: uppercase
  cursor: pointer
  border: 0 !important
  padding: 15px 8px !important

.table-row
  background-color: #fff
.table-row td
  border-bottom: 1px solid #dce1e2 !important
.table__th:hover
  color: #01b9d1

.table--select-all
  width: 18px
  height: 18px
  padding: 0 !important
  border-radius: 50%
  border: 2px solid #becad2

.table-row__td
  padding: 12px 8px !important
  vertical-align: middle !important
  color: #53646f
  font-size: 13px
  font-weight: 400
  position: relative
  line-height: 18px !important
  border: 0 !important

.table-row__img
  width: 36px
  height: 36px
  display: inline-block
  border-radius: 50%
  background-position: center
  background-size: cover
  background-repeat: no-repeat
  vertical-align: middle

.table-row__img2
  width: 66px
  height: 66px
  display: inline-block
  border-radius: 50%
  background-position: center
  background-size: cover
  background-repeat: no-repeat
  vertical-align: middle

.table-row__info
  display: grid
  padding-left: 12px
  grid-template-columns: 1fr 3fr
  vertical-align: middle
.table-row__info2
  display: grid
  padding-left: 12px
  grid-template-rows: 2fr 1fr
  vertical-align: middle
  justify-content: center
.table-row__name
  color: #53646f
  font-size: 14px
  font-weight: 400
  text-align: left
  line-height: 18px
  margin-bottom: 0px
.table-row__name2
  font-size: 22px
  text-align: left
  font-weight: 800
  line-height: 22px
.table-row__small
  color: #9eabb4
  font-weight: 300
  font-size: 12px

.table-row__policy
  color: #53646f
  font-size: 13px
  font-weight: 400
  line-height: 18px
  margin-bottom: 0px

.table-row__p-status, .table-row__status, .table-row__progress
  margin-bottom: 0
  font-size: 13px
  vertical-align: middle
  display: inline-block
  color: #9eabb4

.status:before
  content: ''
  margin-bottom: 0
  width: 9px
  height: 9px
  display: inline-block
  margin-right: 7px
  border-radius: 50%

.status--red
  &:before
    background-color: #e36767

  color: #e36767

.status--blue
  &:before
    background-color: #3fd2ea

  color: #3fd2ea

.status--yellow
  &:before
    background-color: #ecce4e

  color: #ecce4e

.status--green
  color: #6cdb56

  &:before
    background-color: #6cdb56

.status--grey
  color: #9eabb4

  &:before
    background-color: #9eabb4

.table__select-row
  appearence: none
  -moz-appearance: none
  -o-appearance: none
  -webkit-appearance: none
  width: 17px
  height: 17px
  margin: 0 0 0 5px !important
  vertical-align: middle
  border: 2px solid #beccd7
  border-radius: 50%
  cursor: pointer

  &:hover
    border-color: #01b9d1

  &:checked
    background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDI2IDI2IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNiAyNiIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCI+CiAgPHBhdGggZD0ibS4zLDE0Yy0wLjItMC4yLTAuMy0wLjUtMC4zLTAuN3MwLjEtMC41IDAuMy0wLjdsMS40LTEuNGMwLjQtMC40IDEtMC40IDEuNCwwbC4xLC4xIDUuNSw1LjljMC4yLDAuMiAwLjUsMC4yIDAuNywwbDEzLjQtMTMuOWgwLjF2LTguODgxNzhlLTE2YzAuNC0wLjQgMS0wLjQgMS40LDBsMS40LDEuNGMwLjQsMC40IDAuNCwxIDAsMS40bDAsMC0xNiwxNi42Yy0wLjIsMC4yLTAuNCwwLjMtMC43LDAuMy0wLjMsMC0wLjUtMC4xLTAuNy0wLjNsLTcuOC04LjQtLjItLjN6IiBmaWxsPSIjMDFiOWQxIi8+Cjwvc3ZnPgo=)
    background-position: center
    background-size: 7px
    background-repeat: no-repeat
    border-color: #01b9d1

.table-row--overdue
  width: 3px
  background-color: #e36767
  display: inline-block
  position: absolute
  height: calc(100% - 24px)
  top: 50%
  left: 0
  transform: translateY(-50%)

.table-row__edit
  width: 46px
  padding: 8px 17px
  display: inline-block
  background-color: #daf3f8
  border-radius: 18px
  vertical-align: middle
  margin-right: 10px
  cursor: pointer

.table-row__bin
  width: 16px
  display: inline-block
  vertical-align: middle
  cursor: pointer

.table-row--red
  background-color: #fff2f2
.table
  width: 100%
  border-collapse: collapse
.crown svg
  height: 1.1rem
  transform: rotate(-10deg)
  padding-right: 0.5rem

.crown[data-rank="0"] svg
  fill: #FFD84C

.crown[data-rank="1"] svg
  fill: #A6B2C3

.crown[data-rank="2"] svg
  fill: #ED7F12
.position-one
    border-radius: 50%
    border: 2px solid #fbbc05
canvas
    position: absolute
    left: 0
    top: 0
    z-index: 0
    border: 0px solid #000
//.position-current_name
//    color: #ea4335 !important
//.position-current
//    border-radius: 50% !important
//    border: 2px solid #ea4335 !important
</style>
